const doc = [({"da":({"js":({"users":({"passwords":({"edit":({"index":({"your_password_was_changed":"Din adgangskode blev ændret."})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;